import { ChangeDetectorRef, Component, Input } from '@angular/core';

import type { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import type { CustomBillingPlan } from '@recruitee/products-types';
import { LifeCycle } from '@recruitee/utils';

import { AssignedProductService } from '../../services/assigned-product.service';
import { AssignedProductMessageComponent } from './assigned-product-message.component';

@Component({
  selector: 'rt-assigned-product-message-container',
  template: `
    @if (assignedProduct) {
      <rt-assigned-product-message
        [disabled]="disabled"
        (finishOrder)="finishOrder()"
      ></rt-assigned-product-message>
    }
  `,
  styleUrls: ['./assigned-product-message-container.component.less'],
  imports: [AssignedProductMessageComponent],
})
export class AssignedProductMessageContainerComponent {
  @Input() public disabled = false;
  public assignedProduct: CustomBillingPlan | undefined;

  @LifeCycle('onDestroy')
  private onDestroy$: Subject<void>;

  constructor(
    private service: AssignedProductService,
    private cdRef: ChangeDetectorRef,
  ) {}

  public ngOnInit() {
    this.service.data$.pipe(takeUntil(this.onDestroy$)).subscribe(product => {
      this.assignedProduct = product;
      this.cdRef.detectChanges();
    });
  }

  public finishOrder() {
    this.service.goToBilling();
  }
}
